import { createFileRoute } from "@tanstack/react-router";
import AdminSetNewPage from "@/pages/admin/sets/new";
import { useSetsPermissions } from "@/pages/admin/sets";

export const Route = createFileRoute("/app/admin/sets/new")({
  component: RouteComponent,
});

function RouteComponent() {
  const { userCanEditAllSets, userCanViewAllSets, userCanViewAllPrograms } = useSetsPermissions();

  return (
    <AdminSetNewPage
      userCanEditAllSets={userCanEditAllSets}
      userCanViewAllSets={userCanViewAllSets}
      userCanViewAllPrograms={userCanViewAllPrograms}
    />
  );
}
